// extracted by mini-css-extract-plugin
module.exports = {"bold_margin":"woning-scherm_bold_margin__2rCGn","italic_margin":"woning-scherm_italic_margin__3itaY"};